import { render, staticRenderFns } from "./Playlist.vue?vue&type=template&id=5522d4be"
import script from "./Playlist.vue?vue&type=script&lang=js"
export * from "./Playlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports